import { AggregatedError } from '../types/types';

export function formatAggregatedError(error: AggregatedError): string {
    const title = error.title ?? 'Aggregated error';

    if (!error.errors || Object.keys(error.errors).length === 0) return title;

    const groups = Object.entries(error.errors)
        .map(([group, keys]) => `${group}:\n  - ${keys.join('\n  - ')}`)
        .join('\n\n');

    return `${title}\n\n${groups}`;
}
